import { RectangularTextButton } from "components/Base/Buttons";

interface RemoveItemsButtonProps {
  nodeId: number;
  fieldName: string;                 // e.g. "item"
  nodeAPI: { updateField: (id: number, field: string, value: any) => Promise<any> };
  itemType: string;   //either "People" or "Adresses"
  currentItems: any[];
  selectedItems: any[];
  onRemoved?: () => void;            // callback to refresh parent
}

export default function RemoveItemsButton({
  nodeId,
  fieldName,
  nodeAPI,
  itemType,
  currentItems,
  selectedItems,
  onRemoved,
}: RemoveItemsButtonProps) {
  const onRemove = async () => {
    const selectedIds = new Set(selectedItems.map(p => p.id));
    const remaining = currentItems
      .filter(p => !selectedIds.has(p.id))
      .map(p => p.id);

    await nodeAPI.updateField(nodeId, fieldName, remaining);
    onRemoved?.();
  };

  return (
    <RectangularTextButton
      colour="highlighted"
      onClick={onRemove}
      disabled={selectedItems.length === 0}
    >
      Remove {itemType}
    </RectangularTextButton>
  );
}
